<template>
  <div class="new-card">
    <div class="new-card__col flex flex-row items-center justify-between flex-wrap">
      <dr-field
        :id="name"
        v-for="(field, name) in formData"
        :ref="name"
        :key="'main_'+name"
        prefix="credit-card-new"
        :form.sync="formData"
        :field="field"
        :value.sync="formData[name].value"
        :validators.sync="$v.formData[name]"
        :apiErrors.sync="apiErrors[name]"
        :class="[`row-${field.size}`]"
        class="appointment-simple__input"
      />
    </div>

    <div class="new-card__col">
      <div
        :class="{ 'card--flipped': ui.isFlipped }"
        class="card"
      >
        <div
          v-show="!ui.isFlipped"
          class="card__front"
        >
          <p class="card__front-tit">Seu banco</p>

          <p class="card__front-number">
            {{ formData.number.value || formData.number.placeholder }}
          </p>

          <div class="card__front-row">
            <div class="card__front-col">
              <p class="card__front-col-tit">
                Since
              </p>
            </div>

            <div class="card__front-col">
              <p class="card__front-col-tit">
                Valid <br> Thru
              </p>

              <p class="card__front-date">
                {{ formData.expirationDate.value || formData.expirationDate.placeholder }}
              </p>
            </div>
          </div>

          <p class="card__front-name">
            {{ formData.holderName.value || 'Nome Sobrenome' }}
          </p>

          <dr-icon
            fill="white"
            color="white"
            name="cardChip"
            class="card__icon"
          />
        </div>

        <div
          v-show="ui.isFlipped"
          class="card__back"
        >
          <div class="card__back-strip" />

          <div class="card__back-cvv">
            {{ formData.cvv.value || formData.cvv.placeholder }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formData, validations } from '@/data/formData/planPayment'
import drField from '@/components/form/field'

const cardModel = {
  id: 0,
  number: null,
  holderName: null,
  expirationDate: null,
  cvv: null,
  isValid: false
}

export default {
  name: 'PlansCreditCardNew',

  components: { drField },

  props: {
    card: {
      type: Object,
      required: false,
      default: () => ({ ...cardModel })
    }
  },

  model: {
    prop: 'card',
    event: 'change'
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      ui: {
        isFlipped: false
      }
    }
  },

  watch: {
    card: {
      deep: true,
      immediate: true,
      handler (obj) {
        if ('number' in obj) {
          this.formData.number.value = obj.number
        }

        if ('holderName' in obj) {
          this.formData.holderName.value = obj.holderName
        }

        if ('expirationDate' in obj) {
          this.formData.expirationDate.value = obj.expirationDate
        }

        if ('cvv' in obj) {
          this.formData.cvv.value = obj.cvv
        }
      }
    },

    '$v.$invalid': {
      deep: false,
      immediate: true,
      handler () {
        this.emitModel(this.formData)
      }
    },

    formData: {
      deep: true,
      immediate: true,
      handler (obj) {
        this.emitModel(obj)
      }
    }
  },

  created () {
    this.formData.cvv.onFocus = () => {
      this.ui.isFlipped = true
    }

    this.formData.cvv.onBlur = () => {
      this.ui.isFlipped = false
    }
  },

  destroyed () {
    Object.keys(this.formData).forEach((key) => {
      this.formData[key].value = null
    })
  },

  methods: {
    emitModel (obj) {
      const card = {
        id: 0,
        isValid: !this.$v.$invalid
      }

      for (const key in obj) {
        card[key] = obj[key].value
      }

      this.$emit('change', card)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.new-card {
  @apply w-full flex flex-row items-start justify-between;

  &__col {
    @apply self-stretch;
    flex: 1 0 calc(50% - 1rem);

    &:last-of-type {
      @apply ml-4;
      flex: 0 1 20rem;
    }
  }
}

.row-12 {
  flex: 0 0 100%;
}

.row-8 {
  flex: 0 0 calc(((100% - 0.5rem) / 12) * 8);
}

.row-4 {
  flex: 0 0 calc(((100% - 0.5rem) / 12) * 4);
}

.card {
  @apply rounded rounded-lg w-full h-full p-4;
  background: #999999;
  border-radius: 1rem;
  box-sizing: border-box;
  transition: all ease 0.5s;

  &--flipped {
    @apply p-0;
    transform: rotateY(180deg);
    transition: all ease 0.5s;
  }

  &__front {
    @apply w-full h-full relative;
    @apply flex flex-col items-start justify-start;

    &-tit {
      @apply p-0 m-0;
      @apply text-lg uppercase;
      color: rgba(255, 255, 255, 0.5);
      font-size: 1.2rem;
      font-weight: bold;
    }

    &-number {
      @apply m-0 p-0 mt-auto;
      color: white;
      font-size: 1rem;
    }

    &-row {
      @apply w-full mt-2;
      @apply flex flex-row items-start justify-start;
      height: 1.8rem;
    }

    &-col {
      @apply flex flex-row items-start justify-start h-full;
      flex: 0 0 30%;

      &-tit {
        @apply uppercase mr-2;
        color: $color-green;
        font-size: 0.5rem;
      }
    }

    &-date {
      @apply p-0 m-0;
      align-self: flex-end;
      color: white;
      font-size: 0.8rem;
    }

    &-name {
      @apply p-0 m-0 mt-2 uppercase;
      color: white;
    }
  }

  &__back {
    @apply py-8 w-full flex flex-col items-start justify-start;
    transform: rotateY(180deg);

    &-strip {
      @apply block w-full;
      background: black;
      height: 2rem;
    }

    &-cvv {
      @apply m-4 p-2;
      background: white;
      text-align: right;
      width: 60%;
    }
  }

  &__icon {
    @apply absolute;
    bottom: 0;
    right: 0;
    height: 3rem;
    width: 3rem;
  }
}
</style>

<style lang="scss">
.new-card {
  .form-input, .field.cardPayment {
    .has-icon-right {
      input {
        border: 0 !important;
        border-color: white !important;
        font-weight: normal !important;

        &:hover, &:focus {
          background: white !important;
        }
      }
    }

    &.has-error {
      .has-icon-right {
        input {
          &:hover, &:focus {
            background: #fff5f5!important;
          }
        }
      }
    }
  }
}
</style>
